import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { ISellerItem } from '../../../modules/API/Defaults/models/seller';
import CoinIcon from '../../icons/IconLib/CoinIcon';

interface Props {
    sellers: ISellerItem[];
    value: ISellerItem | null;
    onSelect: (seller: ISellerItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const SellerSelector: React.FC<Props> = ({
    sellers,
    value,
    onSelect,
    placeholder = 'בחר משווק',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<ISellerItem>
        items={sellers}
        value={value}
        onSelect={onSelect}
        getKey={(s) => s.SellerID}
        getLabel={(s) => (s.Seller_Desc ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<CoinIcon />}
        className={className}
        emptyLabel='אין משווקים מתאימים'
    />
);

export default SellerSelector;
